<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="row" data-test-view="reviews">
            <div class="col-md-2 hidden-xs">
                <l-side-menu>
                    <l-side-menu-picture :src="icon"></l-side-menu-picture>

                    <l-side-menu-element
                        v-for="item in menu"
                        :key="item.path"
                        :show="item.show"
                        :type="item.type"
                        :icon="item.icon"
                        :label="item.label"
                        :path="item.path"
                        :handler="() => goTo(item.path)"
                        :active="item.active"
                    ></l-side-menu-element>
                </l-side-menu>
            </div>
            <div class="col-md-10">
                <l-card-content>
                    <router-view></router-view>
                </l-card-content>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";
import LSideMenu from "@/components/LSideMenu";
import LSideMenuElement from "@/components/LSideMenuElement";
import LSideMenuPicture from "@/components/LSideMenuPicture";

import icon from "@/img/icons/reviews.png";

export default {
    components: {
        LCardContent,
        LSideMenu,
        LSideMenuElement,
        LSideMenuPicture,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            reviewCycle: {},
            menu: [],
        };
    },
    computed: {
        ...mapGetters({
            getCycleDetails: "reviews/cycles/details",
        }),
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.reviewCycle = this.getCycleDetails(this.id);

                if (!this.reviewCycle._id) {
                    this.$router.push(`/reviews/cycles`);
                }

                this.menu = [
                    {
                        show: true,
                        icon: "fa-caret-left",
                        path: "/reviews/cycles",
                        label: this.$t("reviews.admin.menuBack"),
                        type: "back",
                        active: false,
                    },
                    {
                        show: this.reviewCycle.status.globalStatus !== "draft",
                        icon: "fa-calendar icon-light",
                        path: `/reviews/cycles/edit/${this.id}/status`,
                        label: this.$t(`reviews.admin.menuStatus`),
                    },
                    {
                        show: this.reviewCycle.createdAsRole == "admin",
                        icon: "fa-edit icon-light",
                        path: `/reviews/cycles/edit/${this.id}/basics`,
                        label: this.$t(`reviews.admin.menuOwners`),
                    },
                    {
                        show:
                            this.reviewCycle.status.globalStatus === "draft" &&
                            this.reviewCycle.createdAsRole !== "employee" &&
                            this.reviewCycle.createdAsRole !== "manager",
                        icon: "fa-users icon-light",
                        path: `/reviews/cycles/edit/${this.id}/participants`,
                        label: this.$t(`reviews.admin.menuParticipants`),
                    },
                    {
                        show:
                            this.reviewCycle.createdAsRole !== "employee" &&
                            this.reviewCycle.createdAsRole !== "manager",
                        icon: "fa-sliders-h icon-light",
                        path: `/reviews/cycles/edit/${this.id}/scope`,
                        label: this.$t(`reviews.admin.menuScope`),
                    },
                    {
                        show:
                            this.reviewCycle.createdAsRole !== "employee" &&
                            this.reviewCycle.createdAsRole !== "manager",
                        icon: "fa-question icon-light",
                        path: `/reviews/cycles/edit/${this.id}/questions`,
                        label: this.$t(`reviews.admin.menuQuestions`),
                    },
                    {
                        show:
                            !this.reviewCycle.visibilityLocked &&
                            this.reviewCycle.createdAsRole !== "employee" &&
                            this.reviewCycle.createdAsRole !== "manager",
                        icon: "fa-eye icon-light",
                        path: `/reviews/cycles/edit/${this.id}/visibility`,
                        label: this.$t(`reviews.admin.menuVisibility`),
                    },
                    {
                        show:
                            this.reviewCycle.createdAsRole !== "employee" &&
                            this.reviewCycle.createdAsRole !== "manager",
                        icon: "fa-calendar icon-light",
                        path: `/reviews/cycles/edit/${this.id}/timeline`,
                        label: this.$t(`reviews.admin.menuTimeline`),
                    },
                    {
                        show:
                            this.reviewCycle.createdAsRole !== "employee" &&
                            this.reviewCycle.createdAsRole !== "manager",
                        icon: "fa-envelope icon-light",
                        path: `/reviews/cycles/edit/${this.id}/notifications`,
                        label: this.$t(`reviews.admin.menuNotifications`),
                    },
                    {
                        show:
                            this.reviewCycle.status.globalStatus === "draft" &&
                            this.reviewCycle.createdAsRole !== "employee" &&
                            this.reviewCycle.createdAsRole !== "manager",
                        icon: "fa-check icon-light",
                        path: `/reviews/cycles/edit/${this.id}/confirm`,
                        label: this.$t(`reviews.admin.menuConfirm`),
                    },
                ];

                this.isRouteActive(route.path);

                if (route.path === `/reviews/cycles/edit/${this.id}`) {
                    this.redirect();
                }
            },
        },
    },
    created() {
        this.icon = icon;
    },
    methods: {
        goTo(path) {
            this.$router.push(path);
        },
        isRouteActive(path) {
            this.menu
                .filter(item => item.type !== "back") // Back buttons should never be active!
                .forEach(item => {
                    this.$set(item, "active", path.startsWith(item.path));
                });
        },
        redirect() {
            let route = "";
            if (this.reviewCycle.status.globalStatus === "draft") {
                if (["manager", "employee"].includes(this.reviewCycle.createdAsRole)) {
                    route = `/reviews/cycles/edit/${this.id}/confirm`;
                } else {
                    route = `/reviews/cycles/edit/${this.id}/basics`;
                }
            } else {
                route = `/reviews/cycles/edit/${this.id}/status`;
            }

            this.$router.replace(route);
        },
    },
};
</script>
